// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__3VjB-","Question":"ActiveQuiz_Question__pSzK-"};